import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppConfigService } from '@core/appconfig.service';
import { BrowserService } from '@core/browser.service';

@Component({
  selector: 'zbp-choose-login',
  templateUrl: './choose-login.component.html',
  styleUrls: ['../login.component.scss', './choose-login.component.scss'],
  standalone: false
})
export class ChooseLoginComponent implements OnInit {
  isHighlights = false;

  constructor(
    private titleService: Title,
    public browserService: BrowserService,
    private appConfigService: AppConfigService,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(`Login | ${this.appConfigService.getBrandTitle}`);
  }

  get backToZanerBloserLink(): string {
    return 'http://www.zaner-bloser.com';
  }
}
